<web-settings-body>
    <web-settings-breadcrumbs>
        <div class="breadcrumb-icon" (click)="setSelectedTheme()">
            <a [tooltip]="'site_styles' | translate" placement="bottom">
                <img
                    class="first-breadcrumb-icon"
                    src="./assets/img/websites/lpc-theme-settings-icon.svg"
                    alt="lpc-theme-settings-icon"
                />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="lpc-breadcrumb-arrow-icon"
            />
        </div>
        <div class="breadcrumb-icon" (click)="setSelectedBlock(parentEntity().parentId)">
            <a [tooltip]="'control_block' | translate" placement="bottom">
                <img class="first-breadcrumb-icon" src="assets/img/websites/lpc-block-icon.svg" alt="lpc-block-icon" />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="lpc-breadcrumb-arrow-icon"
            />
        </div>
        <div class="breadcrumb-icon">
            <img src="./assets/img/websites/lpc-column-icon.svg" class="first-breadcrumb-icon" alt="lpc-column-icon" />
        </div>
        <div class="breadcrumb-text">
            <span>{{ "control_column" | translate }}</span>
        </div>
    </web-settings-breadcrumbs>
    <a [href]="'knowledge_base_column_link' | translate" class="kb-link" target="_blank">
        <span class="small sp-icon icon-info"> </span> {{ "knowledge_base_column_tooltip" | translate }}
        <span class="color-light small sp-icon icon-outgoing"> </span>
    </a>

    <div class="panel-options-body overflow-wrapper">
        <form class="form form-horizontal" (submit)="$event.preventDefault()">
            <div class="form-row">
                @if (hasSiblingColumns()) {
                    <div class="form-group mb-20">
                        <label class="col-xs-10 control-label">
                            {{ "control_column_flex_width" | translate }}
                        </label>
                        <div class="col-xs-2">
                            <sp-switch
                                [active]="isFlexibleWidths()"
                                (toggleActiveEvent)="setIsFlexibleWidths($event)"
                            />
                        </div>
                    </div>

                    <div class="form-group mb-20">
                        <label class="col-xs-8 control-label">
                            {{ "control_column_spacing" | translate }}
                        </label>
                        <div class="col-xs-4">
                            <sp-input-num
                                suffixText="px"
                                [min]="COLUMN_GAP_MIN"
                                [max]="COLUMN_GAP_MAX"
                                [value]="columnGap()"
                                (valueChange)="setColumnGap($event)"
                            />
                        </div>
                    </div>
                }

                <div class="form-group">
                    <label class="col-xs-6 control-label">
                        {{ "control_content_alignment" | translate }}
                    </label>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="verticalAlign()"
                            [type]="radioGroupType.verticalPosition"
                            (changeSelectedEvent)="setVerticalAlign($event)"
                        ></sp-radio-group>
                    </div>
                </div>

                <div class="form-group mb-10">
                    <div class="col-xs-12 device-toggle-wrapper">
                        <web-device-toggle />

                        <web-synchronize-style-toggle [active]="syncWithDesktop()" (click)="setSynchronizeStyle()" />
                    </div>
                </div>

                <!--
                    One block for all three device tabs: they edit the same
                    properties, so the component reads and writes whichever
                    breakpoint the toggle above is showing.
                -->
                <div class="form-group mb-0">
                    <p class="col-xs-12 help-block text-muted small">
                        {{ deviceHint() | translate }}
                    </p>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">
                        {{ "control_background_color" | translate }}
                    </label>
                    <div class="col-xs-3">
                        <web-color-picker [color]="backgroundColor()" (colorChangeEvent)="setBackgroundColor($event)" />
                    </div>
                </div>

                <div class="form-group" [class.mb-10]="isIndependentCorners()" [class.mb-20]="!isIndependentCorners()">
                    <label class="col-xs-6 control-label">
                        {{ "control_radius" | translate }}
                    </label>
                    <div class="col-xs-6 custom-corner-wrapper">
                        <button
                            type="button"
                            [tooltip]="'control_custom_radius_toolip' | translate"
                            placement="top"
                            class="btn btn-action btn-custom-corner"
                            [class.active]="isIndependentCorners()"
                            (click)="toggleIndependentCorners()"
                        >
                            <img src="./assets/img/websites/lpc-corner-icon.svg" />
                        </button>

                        @if (isIndependentCorners()) {
                            <!-- Stands in for the single radius input while the corners differ. -->
                            <div class="custom-corner-input">
                                <div class="input-group">
                                    <input class="form-control" value="Mix" disabled />
                                    <div class="input-group-addon">px</div>
                                </div>
                            </div>
                        } @else {
                            <sp-input-num
                                class="custom-corner-input"
                                suffixText="px"
                                [min]="BORDER_RADIUS_MIN"
                                [max]="BORDER_RADIUS_MAX"
                                [value]="borderRadius()"
                                (valueChange)="setBorderRadius($event)"
                            />
                        }
                    </div>
                </div>

                @if (isIndependentCorners()) {
                    <div class="mb-20">
                        <sp-advanced-radius-settings
                            [radiusSettings]="radiusSettings()"
                            (valueChangeEvent)="setAdvancedRadiusSettings($event)"
                        />
                    </div>
                }

                <div class="form-group mb-10">
                    <label class="col-xs-6">
                        {{ "control_padding" | translate }}
                    </label>
                    <div class="col-xs-6 text-right">
                        <div class="preset-padding-buttons">
                            <button type="button" class="btn btn-default btn-sm btn-inline" (click)="setAllPaddings(0)">
                                0
                            </button>
                            <button
                                type="button"
                                class="btn btn-default btn-sm btn-inline"
                                (click)="setAllPaddings(15)"
                            >
                                15
                            </button>
                            <button
                                type="button"
                                class="btn btn-default btn-sm btn-inline"
                                (click)="setAllPaddings(30)"
                            >
                                30
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <div class="col-xs-12 d-flex">
                        <div class="d-flex align-items-center mr-5" style="flex-grow: 1">
                            <sp-input-num
                                suffixText="px"
                                [min]="SIZE_MIN"
                                [max]="SIZE_MAX"
                                [value]="padding()?.left"
                                (valueChange)="setPadding('left', $event)"
                            />
                        </div>
                        <div style="flex-grow: 1">
                            <div class="mb-10">
                                <sp-input-num
                                    suffixText="px"
                                    [min]="SIZE_MIN"
                                    [max]="SIZE_MAX"
                                    [value]="padding()?.top"
                                    (valueChange)="setPadding('top', $event)"
                                />
                            </div>
                            <sp-input-num
                                suffixText="px"
                                [min]="SIZE_MIN"
                                [max]="SIZE_MAX"
                                [value]="padding()?.bottom"
                                (valueChange)="setPadding('bottom', $event)"
                            />
                        </div>
                        <div class="d-flex align-items-center ml-5" style="flex-grow: 1">
                            <sp-input-num
                                suffixText="px"
                                [min]="SIZE_MIN"
                                [max]="SIZE_MAX"
                                [value]="padding()?.right"
                                (valueChange)="setPadding('right', $event)"
                            />
                        </div>
                    </div>
                </div>

                <div class="mb-15">
                    <web-background-image-settings
                        [allowScrollEffect]="false"
                        [background]="background()"
                        (backgroundChange)="setBackground($event)"
                        (showEditImageModalEvent)="showEditImageModal()"
                        (unsplashClickRequested)="openUnsplashModal()"
                    />
                </div>

                <div class="form-group mb-10">
                    <label class="control-label col-xs-9">
                        {{ "control_contour" | translate }}
                    </label>
                    <div class="col-xs-3 control-switch text-right">
                        <sp-switch [active]="isBorder()" (toggleActiveEvent)="setBorder($event)" />
                    </div>
                </div>

                @if (isBorder()) {
                    <sp-advanced-border-settings
                        [borderSettings]="borderSettings()"
                        (valueChangeEvent)="setAdvancedBorderSettings($event)"
                    />
                }

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>

                <div class="form-group" [class.mb-20]="!isShadow()" [class.mb-10]="isShadow()">
                    <label class="col-xs-9 control-label">
                        {{ "control_shadow" | translate }}
                    </label>
                    <div class="col-xs-3 text-right">
                        <sp-switch [active]="isShadow()" (toggleActiveEvent)="setShadow($event)" />
                    </div>
                </div>

                @if (isShadow()) {
                    <sp-shadow-settings-signal [field]="form.shadow" />
                }

                <sp-animation-settings-signal [field]="form.animation" [isDisabled]="hasProductOrCatalogWidget()" />
            </div>
        </form>
    </div>
</web-settings-body>
